import { render, staticRenderFns } from "./TabsWrapper.vue?vue&type=template&id=10d0db08&scoped=true&"
import script from "./TabsWrapper.vue?vue&type=script&lang=js&"
export * from "./TabsWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10d0db08",
  null
  
)

export default component.exports